import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(auth)/signup/business/components/BusinessSignUpForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(auth)/signup/business/components/ReferralSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.4_@babel+core@7.24.6_@opentelemetry+api@1.6.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/link.js");
